import { z } from "zod";
import {
  TopolBlockCssClassSchema,
  TopolBlockAlignSchema,
  TopolBlockSchema,
} from "../commonSchema";

const defaults = {
  alt: "",
  containerWidth: 600,
  href: "",
  padding: "0px 0px 0px 0px",
  src: "",
};

// Here we have to merge the attributes of the image and video blocks
// because both video and image share the same tag name which is discrimator for the union
export const TopolImageAndVideoBlockAttributesBasicSchema = z.object({
  alt: z.string(),
  containerWidth: z.number(),
  href: z.string().trim(),
  padding: z.string(),
  src: z.string().trim(),
  align: TopolBlockAlignSchema.optional(),
  "css-class": TopolBlockCssClassSchema.optional(),
  "fluid-on-mobile": z.enum(["true", "false", ""]).optional(),
  title: z.string().optional(),
  videoSrc: z.string().optional(),
  width: z.union([z.string(), z.number()]).optional(),
  "border-radius": z.string().optional(),
});

export const TopolImageAndVideoBlockAttributesSchema =
  TopolImageAndVideoBlockAttributesBasicSchema.extend({
    alt: z.string().catch(defaults.alt),
    containerWidth: z.number().catch(defaults.containerWidth),
    href: z.string().trim().catch(defaults.href),
    padding: z.string().catch(defaults.padding),
    src: z.string().trim().catch(defaults.src),
  });

export const TopolImageAndVideoBlockStyleAttributesSchema =
  TopolImageAndVideoBlockAttributesSchema.omit({
    alt: true,
    containerWidth: true,
    href: true,
    src: true,
    title: true,
    videoSrc: true,
    "css-class": true,
  });

export const TopolImageAndVideoBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-image"),
  isVideo: z.literal(true).optional().catch(undefined),
  attributes: TopolImageAndVideoBlockAttributesSchema.catch(defaults),
});

export type TopolImageAndVideoBlock = z.infer<
  typeof TopolImageAndVideoBlockSchema
>;
